/*
  Holsper: click anywhere on a product photo to open the full-screen zoom.
  Carried over from the live 6.10 theme (it was added to the end of theme.js there, which the 7.2 update replaced).
  Kept in its own file so theme updates don't remove it again.
  Uses the theme's own "lightbox:open" event, so the zoom view is the theme's (same as the magnifier button).
  The body class "zoom-on-click-enabled" lets holsper-custom.css hide the magnifier button until you hover the photo.
*/
(function () {
  if (window.holsperGalleryZoom) return;
  window.holsperGalleryZoom = true;

  document.addEventListener('click', function (event) {
    var media = event.target.closest('.product-gallery__media[data-media-type="image"]');
    if (!media) return;
    var gallery = media.closest('product-gallery[allow-zoom]');
    if (!gallery) return;
    // Leave real controls alone (the magnifier button handles itself; links and other buttons keep working)
    if (event.target.closest('button, a, [role="button"]')) return;

    // Same list, same order as the theme's zoom view, worked out at click time (photos change with the variant)
    var images = Array.from(gallery.querySelectorAll('.product-gallery__media[data-media-type="image"]:not([hidden])'));
    var index = images.indexOf(media);
    if (index < 0) return;

    // Stop the carousel's own click (previous / next photo)
    event.preventDefault();
    event.stopPropagation();
    gallery.dispatchEvent(new CustomEvent('lightbox:open', { bubbles: true, detail: { index: index } }));
  }, true);

  function enable() { document.body.classList.add('zoom-on-click-enabled'); }
  if (document.body) enable();
  else document.addEventListener('DOMContentLoaded', enable);
})();
